/**
 * ユーザーステータス取得
 */
export default defineNuxtRouteMiddleware(async () => {
  const { refreshSystemSettings, systemSettings } = useSystemSettings()
  const { refreshAccountInfo } = useAuth()

  // ステータス取得
  await Promise.all([refreshSystemSettings(), refreshAccountInfo()])

  if (systemSettings.value?.maintenanceStatus === MaintenanceStatus.StopLogin) {
    return abortNavigation({
      statusCode: 503,
      data: {
        type: 'maintenance',
      },
      fatal: true,
    })
  }
})
